export default "__VITE_ASSET__B2Yi0OW3__"